import { observable, action } from 'mobx';

export default class UpsAddressValidationViewController {
  @observable selectedIndex = 0;

  @action
  setSelectedIndex = (index: number): void => {
    this.selectedIndex = index;
  };

  getSelectedIndex(): number {
    return this.selectedIndex;
  }

  @action
  initializeSelection(): void {
    this.selectedIndex = 0;
  }

  handleConfirm(onConfirm: (index: number) => void): void {
    onConfirm(this.selectedIndex);
  }
}
